import { createSelector } from 'reselect'

const isImpersonating = createSelector([data => data], state => {
  if (!state.permissions.data) return false

  return !!state.permissions.data.permitted
})

export { isImpersonating }
